import type { TFunction } from 'i18next';
import type { Agent } from '../services/agents.service';

/** Localized agent display fields; falls back to API strings for unknown keys. */
export function getAgentDisplayFields(agent: Agent, t: TFunction<'agents'>) {
  const base = `catalog.${agent.key}`;
  return {
    name: t(`${base}.name`, { defaultValue: agent.name }),
    role: t(`${base}.role`, { defaultValue: agent.role }),
    tagline: t(`${base}.tagline`, { defaultValue: agent.tagline }),
  };
}

export function getPlanLabel(plan: Agent['plan'], t: TFunction<'agents'>) {
  return t(`plans.${plan}`, { defaultValue: plan });
}
